import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { saveAs } from 'file-saver-es';
import * as fns from 'date-fns/fp';

export interface ModalWindowData {
  title: string;
  description: string;
  matContentClasses?: string;
  contentList?: string[];
  error?: boolean;
  // Soft-yellow "warning" styling instead of the red error banner. Takes
  // precedence over `error` when set.
  warning?: boolean;
  descriptionAlignment?: 'left' | 'center';
  requestData?: any;
}

@Component({
  selector: 'md-modal-window',
  templateUrl: 'modal-window.component.html',
  styleUrls: ['./modal-window.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalWindowComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalWindowData,
  ) {}

  close() {
    this.dialogRef.close();
  }

  downloadRequestData() {
    const blob = new Blob([JSON.stringify(this.data.requestData)], {
      type: 'plain/text',
    });
    const fileName = 'debug-data-' + fns.format('yyyy-MM-dd_HH:mm:ss', new Date());
    saveAs(blob, fileName);
  }
}
